export default "__VITE_ASSET__BxJ9XIbA__"